<template>
    <!--Waiting List Enrollment Step One-->
    <div class="enroll-info-screen">
        <div class="enroll-wrapper">
            <!--Heading-->
            <h6 class="sub-title">{{ $ml.get("waitingListEnroll.subTitle") }}</h6>
            <p class="highlight-text">{{ $ml.get("waitingListEnroll.step1") }}</p>
            <!--Listing stylist cards component-->
            <listing-cards :waitingList="1" @add-card-screen="addCardScreenMethod"
                @check-number-of-cards="checkUserCard"></listing-cards>
            <!--Continue to next section-->
            <div v-if="!addNewCard && !addCardScreen && hasCard" class="next-step">
                <button :disabled="braintreeCards.length === 0 && !hasCard" @click="changeScreen('enroll-step-two')"
                    :class="braintreeCards.length === 0 && !hasCard ? 'disabled-button' : ''"
                    class="primary-btn extra-small mobile">
                    Continue
                </button>
                <a class="main-text-link" href="#">Save for later</a>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../../services/vuex";
import api from "../../../../services/api_endpoints";
import eventBus from "../../../../services/event_bus";
import ListingCards from "../../general-components/listing_cards.vue";



export default {
    data() {
        return {
            addNewCard: false,
            enrollmentCost: 1,
            braintreeCards: [],
            addCardScreen: false,
            hasCard: false,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        if (store.state.adminDetails.user) {
            this.checkUserCard();
        }

        let self = this;
        eventBus.$on("admin_details_loaded", function () {
            self.checkUserCard();
        });
        this.enrollmentCost = process.env["VUE_APP_ENROLLMENT_COST"];

        if (this.braintreeCards.length === 0) {
            this.checkUserCard();
        }
    },
    components: { ListingCards },
    methods: {
        changeScreen(screen) {
            this.$emit('change-screen', screen);
        },
        checkbraintreeCardsLength(length) {
            this.braintreeCardsLength = length;
        },
        checkUserCard() {
            this.$http.get(api.actions.get_braintree_customer_cards).then((response) => {

                if (response.data.error == true || !response.data.response.length) {
                    this.hasCard = false;
                    return;
                }

                this.hasCard = true;
                this.braintreeCards = response.data.response;
            });
        },
        addCardScreenMethod(card) {
            this.addCardScreen = card;
        }

    },
};
</script>
